/* Rupee glyph in place of "Rs."

   Client, 31 Aug and again 10 Sep: "Please make sure we have the ₹ symbol
   everywhere instead of Rs."

   Every price on the site comes out of Shopify's money filter, which prints
   the store's money_format setting. That setting is "Rs. {{amount}}" and it
   lives in Settings > General > Store currency > Change formatting. A theme
   token cannot touch it, so the correct fix is one admin edit. Until that is
   made, this rewrites the rendered text.

   Scope is deliberately narrow: only "Rs" or "Rs." immediately followed by a
   digit, which is a price and nothing else. Prose that mentions rupees in
   words is left alone. Runs once on load and again on every DOM change, so
   the cart drawer, which re-renders after each add, stays correct.

   Delete this file the day money_format is changed; it will then match nothing
   and cost a MutationObserver for no reason. */
(function () {
  var RX = /\bRs\.?\s?(?=\d)/g;

  function fix(root) {
    var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
      acceptNode: function (n) {
        if (!n.nodeValue || n.nodeValue.indexOf('Rs') === -1) return NodeFilter.FILTER_REJECT;
        var p = n.parentElement;
        if (!p) return NodeFilter.FILTER_REJECT;
        var t = p.tagName;
        if (t === 'SCRIPT' || t === 'STYLE' || t === 'TEXTAREA' || p.isContentEditable) return NodeFilter.FILTER_REJECT;
        return NodeFilter.FILTER_ACCEPT;
      }
    });
    var nodes = [];
    while (walker.nextNode()) nodes.push(walker.currentNode);
    for (var i = 0; i < nodes.length; i++) {
      var v = nodes[i].nodeValue;
      var w = v.replace(RX, '₹');
      if (w !== v) nodes[i].nodeValue = w;
    }
  }

  function start() {
    fix(document.body);
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      requestAnimationFrame(function () { pending = false; fix(document.body); });
    }).observe(document.body, { childList: true, subtree: true, characterData: true });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
